(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("httpService", [], factory);
	else if(typeof exports === 'object')
		exports["httpService"] = factory();
	else
		root["httpService"] = factory();
})(self, function() {
return 